module.exports = __webpack_public_path__ + "img/réalisation récupérateur de pente.22f57e06.jpg";